import { createActions } from 'reduxsauce';

const { Types: types, Creators: actions } = createActions({
    // add order status type
    requestSubmitOrderStatusType: ['id', 'data'],
    submitOrderStatusTypeSucceeded: ['data'],
    submitOrderStatusTypeFailed: ['errors'],

    // clear state
    clearOrderStatusTypeCreateState: null,
});

export default {
    // add order status type
    [types.REQUEST_SUBMIT_ORDER_STATUS_TYPE]: (state) => ({
        ...state,
        create: {
            ...state.create,
            submitting: true,
            errors: null,
        },
    }),
    [types.SUBMIT_ORDER_STATUS_TYPE_SUCCEEDED]: (state, { data }) => ({
        ...state,
        create: {
            ...state.create,
            submitting: false,
            statusTypeDetails: data,
            success: true,
        },
    }),
    [types.SUBMIT_ORDER_STATUS_TYPE_FAILED]: (state, { errors }) => ({
        ...state,
        create: {
            ...state.create,
            submitting: false,
            success: false,
            errors,
        },
    }),

    // clear state
    [types.CLEAR_ORDER_STATUS_TYPE_CREATE_STATE]: (state) => ({
        ...state,
        create: {
            ...state.create,
            statusTypeDetails: null,
            success: false,
            errors: null,
        },
    }),
};

export { types, actions };